module.exports = __webpack_public_path__ + "static/media/process_3.513104d2.png";